module.exports = require("asciimath-to-latex");


//////////////////
// WEBPACK FOOTER
// external "asciimath-to-latex"
// module id = 2
// module chunks = 0